import React from "react";

const ContactMapSection = () => {
  return (

    <section className="w-full px-6 pb-16 lg:pb-24 bg-white">

      {/* Main Container */}
      <div className="max-w-[1700px] mx-auto overflow-hidden rounded-b-[12px]">

        
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3198.877798819804!2d-4.4697579!3d36.70147430000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72f7577da1d45f%3A0x87d9e80aa3bb948c!2sC.%20la%20Orotava%2C%20129%2C%20Cruz%20de%20Humilladero%2C%2029006%20M%C3%A1laga%2C%20Spain!5e0!3m2!1sen!2sin!4v1785994605593!5m2!1sen!2sin"
        width="100%"
          height="700"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="w-full h-[300px] md:h-[400px] lg:h-[400px]"
          title="Google Map"
         ></iframe>

      </div>

    </section>

  );
};

export default ContactMapSection;